jQuery(document).ready(function($){
    $('.navbar-burger').click(function(){
        toggleMenu($(this).closest('.navbar'));
    })
});

function showMenu( $navbar ){
    $navbar.addClass('is-active');
    $navbar.find('.navbar-menu').addClass('is-active');
    $navbar.find('.navbar-burger').addClass('is-active');
}

function hideMenu( $navbar ){
    $navbar.removeClass('is-active');
    $navbar.find('.navbar-menu').removeClass('is-active');
    $navbar.find('.navbar-burger').removeClass('is-active');
}

function toggleMenu( $navbar ){
    if ($navbar.hasClass('is-active')) {
        hideMenu($navbar);
    } else {
        showMenu($navbar);
    }
}